import { NavLink } from "react-router-dom";
import LogoNCSAWhite from "../img/logo-ncsa-white.png";
import IconYoutube from "../img/icons/icon-youtube.svg";
import IconFacebook from "../img/icons/icon-facebook.svg";
import IconTwitter from "../img/icons/icon-twitter.svg";
import IconInstagram from "../img/icons/icon-instagram.svg";
import IconLinkedin from "../img/icons/icon-linkedin.svg";
import {Config} from "../Config";
import React from "react";

export default function Footer(prop) {
    let [data, setData] = React.useState(null);

    React.useEffect(() => {

        (async function() {
            try {
                const resView = await getContact();

                if(prop !== null && prop.lang === 'en') {
                    resView.title_th = resView.title;
                    resView.title = resView.title_en;
                    resView.phone_detail = resView.phone_detail_en;
                    resView.contact = resView.contact_en;
                    resView.address = resView.address_en;
                }

                setData(resView);
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getContact () {
        const response = await fetch(Config.apiUrl +'/contact/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <footer className="footer" data-aos="fade-in">
                <div className="container">
                    <div className="footer-logo">
                        <img className="logo" src={LogoNCSAWhite} alt="" />
                        <div>
                            <h5>{data?.title_th ?? data?.title}</h5>
                            <p>{data?.title_en}</p>
                        </div>
                    </div>

                    <div className="footer-info">
                        <h3>{prop.lang === 'en' ? 'Contact':'ติดต่อสำนักงาน'}</h3>

                        <p>{data?.title}<br />{data?.address}</p>
                    </div>

                    <div className="footer-links">
                        <div className="cols">
                            <h4>{prop.lang === 'en' ? 'NCSA Database':'ฐานข้อมูลของ สกมช.'}</h4>
                            <ul className="nav nav-footer">
                                <li><NavLink to={prop.lang === 'en' ? '/en/research':'/research'}>{prop.lang === 'en' ? 'Research':'ข้อมูลผลงานวิจัย'}</NavLink></li>
                                <li><a href={prop.lang === 'en' ? '/en/researcher':'/researcher'}>{prop.lang === 'en' ? 'Researcher':'ข้อมูลนักวิจัย'}</a></li>
                                <li><a href={prop.lang === 'en' ? '/en/agency':'/agency'}>{prop.lang === 'en' ? 'Agency':'ข้อมูลหน่วยงาน'}</a></li>
                                <li><NavLink to={prop.lang === 'en' ? '/en/entrepreneur':'/entrepreneur'}>{prop.lang === 'en' ? 'Entrepreneur':'ข้อมูลผู้ประกอบการ'}</NavLink></li>
                            </ul>
                        </div>

                        <div className="cols">
                            <ul className="nav nav-footer">
                                <li><NavLink to={prop.lang === 'en' ? '/en/scholarship':'/scholarship'}>{prop.lang === 'en' ? 'Scholarship':'ทุนวิจัย'}</NavLink></li>
                                <li><NavLink to={prop.lang === 'en' ? '/en/news':'/news'}>{prop.lang === 'en' ? 'News':'ข่าวสาร'}</NavLink></li>
                                <li><NavLink to={prop.lang === 'en' ? '/en/contact':'/contact'}>{prop.lang === 'en' ? 'Contact us':'ติดต่อเรา'}</NavLink></li>
                            </ul>
                        </div>

                        <div className="cols w-340">
                            <p className="tel"><NavLink to={"tel:" + data?.phone}>{data?.phone}</NavLink></p>
                            <p>{data?.phone_detail}</p>

                            <hr />

                            <div className="followus">
                                {
                                    data?.youtube ? <NavLink to={data?.youtube} target="_blank"><img className="icons" src={IconYoutube} alt="" /></NavLink>:''
                                }

                                {
                                    data?.facebook ? <NavLink to={data?.facebook} target="_blank"><img className="icons" src={IconFacebook} alt="" /></NavLink>:''
                                }

                                {
                                    data?.twitter ? <NavLink to={data?.twitter} target="_blank"><img className="icons" src={IconTwitter} alt="" /></NavLink>:''
                                }

                                {
                                    data?.instagram ? <NavLink to={data?.instagram} target="_blank"><img className="icons" src={IconInstagram} alt="" /></NavLink>:''
                                }

                                {
                                    data?.linkedin ? <NavLink to={data?.linkedin} target="_blank"><img className="icons" src={IconLinkedin} alt="" /></NavLink>:''
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            <div className="footer-copyright" data-aos="fade-in" data-aos-offset="0">
                <div className="container">
                    <p>
                        {prop.lang === 'en' ? 'Copyright © 2024, All Right Reserved. NCSA':'ลิขสิทธิ์ © 2024 สงวนลิขสิทธิ์ NCSA'}
                        <span className="d-none d-sm-inline">|</span>
                        <br className="d-block d-sm-none" />
                        {prop.lang === 'en' ? 'National Cyber Security Agency':'สำนักงานคณะกรรมการการรักษาความมั่นคงปลอดภัยไซเบอร์แห่งชาติ (สกมช.)'}
                    </p>
                </div>
            </div>
        </>
    );
} 